import React from "react";

function Subtitle({ children }) {
  return <h2 class="text-2xl font-bold my-3">{children}</h2>;
}

export default Subtitle;
